import { toastr } from "react-redux-toastr";
import errorMessage from "./ErrorMessages/errorMessages_en";
import errorMessage_es from "./ErrorMessages/errorMessages_es";
import errorMessage_fr from "./ErrorMessages/errorMessages_fr";
import errorMessage_it from "./ErrorMessages/errorMessages_it";
import errorMessage_pt from "./ErrorMessages/errorMessages_pt";
import errorMessage_he from "./ErrorMessages/errorMessages_he";
import errorMessage_ar from "./ErrorMessages/errorMessages_ar";

const errorMessages = {
    'en': errorMessage,
    'en-US': errorMessage,
    'es': errorMessage_es,
    'fr-FR': errorMessage_fr,
    'it-IT': errorMessage_it,
    'pt-PT': errorMessage_pt,
    'ar': errorMessage_ar,
    'he': errorMessage_he
};

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : 'en';
};

const showToaster = async ({ messageId, toasterType, requestContent }) => {
    const selectedLang = getCookie("lang");
    const messages = errorMessages[selectedLang] || errorMessage;
    
    const title = await messages(toasterType);
    const result = await messages(messageId, requestContent);
    
    return toastr[toasterType](title, result);
};

export default showToaster;